export default __webpack_public_path__ + "static/media/logo-sm.7f895a85.png";